






















import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { InsertTown } from "@/api/pdOutPatient/pdCity";

@Component
export default class extends AbpBase {
  @Prop() data: any;
  @Prop() value: boolean;
  form: any = {};
  saveLoading = false;

  rules: any = {
    code: [{ required: true, message: "请输入", trigger: "blur" }],
    name: [{ required: true, message: "请输入", trigger: "blur" }],
  };

  created() {
    this.form.parentCode = this.data.parentCode;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.saveLoading = true;
        let res: any = {};
        if (this.data.mode == "add") {
          res = await InsertTown(this.form);
        }
        if (res.code == 2000) {
          this.$emit("save-success");
          this.$emit("input", false);
        }
        this.saveLoading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/town/addOrEdit.vue